import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class UserGrid extends BaseComponent {

	//remember if the attribute is added it's true
	static get properties() {
		return {
			admin: {type: Boolean}
		};
	}
	
	constructor() {
		super();
		
		var userGrid = this;
		setTimeout(function(){
			userGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var userGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filtercompany',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;' + (userGrid.admin ? '' : 'display: none;'),
					label: 'Company',
					'item-value-path': 'code',
					'item-label-path': 'description',
					required: true,
					postinit: function(combo) {
						if (userGrid.admin) {
							Service.getCompanyService().getCompaniesLookup().then(function(data){
								combo.items = data;
							});
						}
					},
					placeHolder: 'Select',
					listeners: {
						change: function() {
							var companyId = ElementUtil.query(toolbar, 'filtercompany').value;
							if (companyId) {
								ElementUtil.query(toolbar, 'add').disabled = false;
							} else {
								ElementUtil.query(toolbar, 'add').disabled = true;
							}							
							actionRefresh();
						}
					}					
				},
				{
					tag: 'vaadin-text-field',
					itemid: 'filterValue',
					'class': 'spacer-toolbar-item',
					'keep-open': true,
					label: 'Filter By User Id',
					listeners: {
						input: {
							fn: function() {
								actionRefresh();
							},
							buffer: 2000
					    }
					}
				},				
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					disabled: true,	
					'class': 'spacer-toolbar-item',										
					permissions: ['ADMIN_USER_MANAGEMENT:WRITE', 'COMPANY_USER_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')
					],
					listeners: {
						click: function() {							
							addEditAction();
						}
					}
				},				
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,					
					permissions: ['ADMIN_USER_MANAGEMENT:WRITE', 'COMPANY_USER_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')
					],
					listeners: {
						click: function() {							
							addEditAction(grid.selectedItems[0]);
						}
					}
				},
				{
					tag: 'dl-action-button',					
					'class': 'spacer-toolbar-item',															
					style: 'width: 230px',
					children:[
						ElementUtil.makeIcon('vaadin:cog', ' Tools')						
					],
					properties: {
						menu: [
							{
								tag: 'vaadin-item',
								itemid: 'tools-reset',
								disabled: true,
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:rotate-right"></vaadin-icon> Reset Password',
								listeners: {
									click: function(event) {
										actionResetPassword(grid.selectedItems[0]);
									}
								}
							},
							{
								tag: 'vaadin-item',
								itemid: 'tools-activate',
								disabled: true,
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:check"></vaadin-icon> Activate/Disable',
								listeners: {
									click: function(event) {
										actionActivateDisable(grid.selectedItems[0]);
									}
								}
							},							
							{
								tag: 'vaadin-item',
								itemid: 'tools-lock',
								disabled: true,
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:lock"></vaadin-icon> Lock/Unlock',
								listeners: {
									click: function(event) {
										actionLock(grid.selectedItems[0]);
									}
								}
							},							
							{
								tag: 'hr',
								itemid: 'tool-separator'
							},
							{
								tag: 'vaadin-item',
								itemid: 'tools-managecompanies',
								disabled: true,
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:building"></vaadin-icon> Manage Companies',
								listeners: {
									click: function(event) {
										actionCompanies(grid.selectedItems[0]);
									}
								}
							},
							{
								tag: 'vaadin-item',
								itemid: 'tools-userlookup',
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:user"></vaadin-icon> User Lookup',
								listeners: {
									click: function(event) {
										actionUserLookup();
									}
								}
							}
						]
					}
				},				
				{
					tag: 'dl-action-button',						
					theme: 'error primary',
					itemid: 'delete',
					disabled: true,
					'class': 'spacer-toolbar-item',
					style: 'float: right; margin-top: 18px;',
					permissions: ['ADMIN_USER_MANAGEMENT:DELETE', 'ADMIN_USER_MANAGEMENT:DELETE'],
					children:[
						ElementUtil.makeIcon('vaadin:trash', ' Delete')
					],
					listeners: {
						click: function() {
							actionDelete(grid.selectedItems[0]);
						}
					}
				}
			]
		});
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},
			children: [				
				{						
					path: 'userId',
					header: 'User Id',
					width: '5em',
					renderer: function(root, column, rowData) {
						if (!rowData.item.ssoUser) {
							root.innerHTML = rowData.item.userId + " (Local)";
						} else {
							root.innerHTML = rowData.item.userId;
						}
					}
				},
				{						
					path: 'firstname',
					header: 'First Name',
					width: '5em'
				},							
				{						
					path: 'lastname',
					header: 'Last Name',					
					width: '5em'
				},
				{
					path: 'email',
					header: 'Email',					
					'text-align': 'center',
					'flex-grow': '1'
				},
				{
					path: 'phone',
					header: 'Phone',					
					'text-align': 'center',
					width: '5em'
				},
				{
					path: 'primaryCompanyUser',
					header: 'Primary Company User',					
					'text-align': 'center',
					width: '7em'
				},
				{
					path: 'activeStatus',
					header: 'Active Status',					
					'text-align': 'center',
					width: '5em'
				},
				{
					path: 'accountStatus',
					header: 'Account Status',
					'text-align': 'center',
					width: '5em',
					renderer: function(root, column, rowData) {
						var status = 'Locked';
						root.classList.remove(...root.classList);
						if (rowData.item.accountStatus === 'A') {
							status = "Open";																	
							root.classList.add('grid-item-success-highlight');
						} else {
							root.classList.add('grid-item-fail-highlight');
						}
						root.innerHTML = status;
					}				
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {
						ElementUtil.query(toolbar, 'edit').disabled = false;
						if (ElementUtil.query(toolbar, 'tools-reset')) {
							ElementUtil.query(toolbar, 'tools-reset').disabled = false; 
							ElementUtil.query(toolbar, 'tools-activate').disabled = false; 
							ElementUtil.query(toolbar, 'tools-lock').disabled = false; 
							ElementUtil.query(toolbar, 'tools-managecompanies').disabled = false; 
						}
						ElementUtil.query(toolbar, 'delete').disabled = false; 						
					} else {
						ElementUtil.query(toolbar, 'edit').disabled = true;
						if (ElementUtil.query(toolbar, 'tools-reset')) {
							ElementUtil.query(toolbar, 'tools-reset').disabled = true; 
							ElementUtil.query(toolbar, 'tools-activate').disabled = true; 
							ElementUtil.query(toolbar, 'tools-lock').disabled = true; 
							ElementUtil.query(toolbar, 'tools-managecompanies').disabled = true;
						}
						ElementUtil.query(toolbar, 'delete').disabled = true; 
					}	
				}
			}
		});
		
		var footer = ExportUtil.createExportFooter({
			grid: grid,
			itemid: 'users',
			onDetail: function() {
				ExportUtil.exportGridItemsAsCsv(grid.items, 'users.csv');
			}
		});

		var gridLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});		
		userGrid.append(gridLayout);
		
		
		//hide admin only options
		if (!userGrid.admin) {
			//make sure it's rendered
			setTimeout(function(){
				ElementUtil.query(toolbar, 'tool-separator').classList.add('hide');
				ElementUtil.query(toolbar, 'tools-managecompanies').classList.add('hide');
				ElementUtil.query(toolbar, 'tools-userlookup').classList.add('hide');
				ElementUtil.query(toolbar, 'add').disabled = false;
				
			}, 10);			
		}
		
		//hide item based on permissions
		setTimeout(function(){
			Service.getUserService().getCurrentUser().then(function(user) {
				if (!user.hasPermission('ADMIN_USER_MANAGEMENT:RESET_PASSWORD') &&
					!user.hasPermission('COMPANY_USER_MANAGEMENT:RESET_PASSWORD')) {
					ElementUtil.query(toolbar, 'tools-reset').classList.add('hide');
				}
				if (!user.hasPermission('ADMIN_USER_MANAGEMENT:UPDATE_STATUS') &&
					!user.hasPermission('COMPANY_USER_MANAGEMENT:UPDATE_STATUS')) {
					ElementUtil.query(toolbar, 'tools-activate').classList.add('hide');
				}
				if (!user.hasPermission('ADMIN_USER_MANAGEMENT:UPDATE_LOCK_STATUS') &&
					!user.hasPermission('COMPANY_USER_MANAGEMENT:UPDATE_LOCK_STATUS')) {
					ElementUtil.query(toolbar, 'tools-lock').classList.add('hide');
				}
				if (!user.hasPermission('ADMIN_USER_MANAGEMENT:MANAGE_COMPANIES') &&
					!user.hasPermission('COMPANY_USER_MANAGEMENT:MANAGE_COMPANIES')) {
					ElementUtil.query(toolbar, 'tools-managecompanies').classList.add('hide');
				}
			});
		}, 10);
		
		
		var actionRefresh = function() {
					
			var currentFilter = {
				filterField: 'userId',
				filterValue: ElementUtil.query(toolbar, 'filterValue').value
			};
			
			if (userGrid.admin) {
				var companyId = ElementUtil.query(toolbar, 'filtercompany').value;
				if (companyId) {
					var loadMask = grid.showLoading();
					
					Service.getUserService().getUsersForCompany(companyId, currentFilter).then(function(users){
						grid.activeItem = null;
						grid.items = users.data;
						loadMask.remove();
					});
				}
			} else {
				var loadMask = grid.showLoading();
				Service.getUserService().getUsersForCompany(null, currentFilter).then(function(users){						
					grid.activeItem = null;
					grid.items = users.data;
					loadMask.remove();
				});
			}
		};
		actionRefresh();
	
		var actionDelete = function(record) {
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete user <b>' + record.userId + '</b>? <br><br> This will not affect company or auditing data.',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Deleting user...');													
							
							Service.getUserService().deleteUser(record.userId).then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Deleted user: ' + record.userId, {									
									theme: 'success'
								});
								actionRefresh();
							});															
							
						}	
					},
					{
						text: 'No'
					}
				]
			});
		};		
		
		var addEditAction = function(record) {
			
			if (record) {
				
				var userWin = ElementUtil.create({
					tag: 'dl-dialog',
					title: 'Edit User',
					icon: 'vaadin:edit',
					listeners: {
						ready: function() {						
							userWin.show();

							var userForm = ElementUtil.create({
								tag: 'dl-user-profile-form',
								itemid: 'profileForm',
								showcancel: true,
								slot: 'primary',
								listeners: {
									ready: function() {
										userForm.loadUser(record);										
									},
									saved: function(event) {
										actionRefresh();
										userWin.close();
									},
									cancel: function(event) {
										userWin.close();
									}
								}
							});

							var flexLayout = ElementUtil.create({
								tag: 'dl-flex-layout',
								children: [								
									userForm
								]
							});

							//allow window finish showing so form can get focus
							setTimeout(function(){
								userWin.addToContentElement(flexLayout);	
							}, 10);

						}
					}
				});
				
			} else {
				
				Service.getBrandingService().getCurrentBranding().then(function(branding) {
					
					var ssoEnabled = branding.ssoEnabled;
					
					var showAddWin = function(companyId) {
						var addWin = ElementUtil.create({
						tag: 'dl-dialog',
						title: 'Add User',
						icon: 'vaadin:plus',
						listeners: {
							ready: function() {						
								addWin.show();

								var localAccountForm = ElementUtil.create({
									tag: 'div',
									'class': (ssoEnabled ? 'hide' : ''),
									children: [
										{
											tag: 'vaadin-form-layout',
											children: [
												{
													tag: 'vaadin-text-field',
													itemId: 'fieldUserId',
													name: 'userId',
													label: 'User Name',													
													maxlength: 120
												},
												{
													tag: 'vaadin-password-field',
													itemId: 'fieldPassword',
													name: 'password',
													label: 'Password',
													autocomplete: 'new-password',													
													maxlength: 120
												},
												{
													tag: 'vaadin-password-field',
													itemId: 'fieldConfirmPassword',
													name: 'confirmPassword',
													label: 'Confirm Password',
													autocomplete: 'new-password',													
													maxlength: 120
												},
												{
													tag: 'vaadin-combo-box',
													itemId: 'fieldRole',
													label: 'Role',
													name: 'roleId',
													'item-value-path': 'roleId',
													'item-label-path': 'roleName',														
													postinit: function(combo) {
														if (userGrid.admin) {
															Service.getSecurityService().getSecurityRoles(companyId).then(function(data){
																combo.items = data;																																															
															});
														} else {
															Service.getSecurityService().getSecurityRoles().then(function(data){
																combo.items = data;																
															});
														}
													},
													placeHolder: 'Select'													
												}
											]
										}
									]
								});

								var ssoAccountForm = ElementUtil.create({
									tag: 'div',
									'class': (ssoEnabled ? '' : 'hide'),
									children: [
										{
											tag: 'vaadin-form-layout',
											children: [
												{
													tag: 'vaadin-email-field',
													itemId: 'fieldSSOUserId',
													name: 'fieldSSOUserId',
													label: 'SSO User Name (Email Address)',													
													maxlength: 120
												},											
												{
													tag: 'vaadin-combo-box',																																																						
													itemId: 'fieldSSORoleId',
													label: 'Role',
													name: 'fieldSSORoleId',
													'item-value-path': 'roleId',
													'item-label-path': 'roleName',														
													postinit: function(combo) {
														if (userGrid.admin) {
															Service.getSecurityService().getSecurityRoles(companyId).then(function(data){
																combo.items = data;																																															
															});
														} else {
															Service.getSecurityService().getSecurityRoles().then(function(data){
																combo.items = data;																																													
															});
														}
													},
													placeHolder: 'Select'													
												}
											]
										}
									]								
								});							


								var formPanel = ElementUtil.create({
									tag: 'dl-form-panel',								
									itemid: 'form',
									children: [
										{
											tag: 'fieldset',
											children: [
												{
													tag: 'legend',
													innerHTML: 'Profile'												
												},
												{
													tag: 'vaadin-form-layout',
													children: [
														{
															tag: 'vaadin-text-field',
															name: 'firstname',
															label: 'First Name',
															required: true,
															maxlength: 120
														},
														{
															tag: 'vaadin-text-field',
															name: 'lastname',
															label: 'Last Name',
															required: true,
															maxlength: 120
														},
														{
															tag: 'vaadin-email-field',
															name: 'email',
															label: 'Email',
															required: true,
															maxlength: 120
														},
														{
															tag: 'vaadin-text-field',
															name: 'phone',
															label: 'Phone',
															maxlength: 120
														}
													]
												}									
											]
										},
										{
											tag: 'fieldset',
											children: [
												{
													tag: 'legend',
													innerHTML: 'Security'												
												},
												{
													tag: 'vaadin-checkbox',
													itemId: 'localChkbox',
													name: 'localAccount',
													label: 'Local Account',
													'class': (ssoEnabled && userGrid.admin ? '' : 'hide'),													
													listeners: {
														change: function(e) {
															var chkBox = e.srcElement;
															if (chkBox.checked) {
																localAccountForm.classList.remove('hide');
																ssoAccountForm.classList.add('hide');
															} else {
																localAccountForm.classList.add('hide');
																ssoAccountForm.classList.remove('hide');
															}
														}
													}
												},
												localAccountForm,
												ssoAccountForm
											]
										},									
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {		
															var formData = formPanel.getData();			
															
															var valid = true;
																
															if (ssoEnabled) {
																if (!formData.fieldSSOUserId) {
																	var field = ElementUtil.query(formPanel, 'fieldSSOUserId');
																	field.errorMessage = 'Username is required';
																	field.invalid = true;
																	valid = false;
																}
																if (!formData.fieldSSORoleId) {
																	var field = ElementUtil.query(formPanel, 'fieldSSORoleId');
																	field.errorMessage = 'Role is required';
																	field.invalid = true;
																	valid = false;
																}
															} else {
																if (!formData.userId) {
																	var field = ElementUtil.query(formPanel, 'fieldUserId');
																	field.errorMessage = 'Username is required';
																	field.invalid = true;
																	valid = false;
																}
																if (!formData.roleId) {
																	var field = ElementUtil.query(formPanel, 'fieldRole');
																	field.errorMessage = 'Role is required';
																	field.invalid = true;
																	valid = false;
																}
																if (!formData.password) {
																	var field = ElementUtil.query(formPanel, 'fieldPassword');
																	field.errorMessage = 'Password is required';
																	field.invalid = true;
																	valid = false;
																}
																if (!formData.confirmPassword) {
																	var field = ElementUtil.query(formPanel, 'fieldConfirmPassword');
																	field.errorMessage = 'Confirm Password is required';
																	field.invalid = true;
																	valid = false;
																}																
																if (formData.password !== formData.confirmPassword) {
																	window.DL.MessageUtil.showOkMessage('New Password and Confirm Password needs to be the same.');													
																}
															}	
															

															if (valid) {			
																
																var ssoUser = !ElementUtil.query(formPanel, 'localChkbox').checked;
																if (!ssoEnabled) {
																	ssoUser = false;
																}
																
																formPanel.submitForm({		
																	preSubmit: function(data) {
																		var newUserModel = {
																			securityUser: {
																				userId: (ssoUser ? data.fieldSSOUserId : data.userId),
																				password: data.password
																			},
																			userProfile: {
																				userId: (ssoUser ? data.fieldSSOUserId : data.userId),
																				firstname: data.firstname,
																				lastname: data.lastname,
																				email: data.email,
																				phone: data.phone
																			},
																			ssoUser: ssoUser,
																			companies: [
																				{
																					primaryCompany: true,
																					securityCompanyUserPk: {
																						companyId: companyId,
																						userId: (ssoUser ? data.fieldSSOUserId : data.userId)
																					}
																				}
																			],
																			roleMap: {}
																		};
																		newUserModel.roleMap[companyId] = [];
																		if (ssoUser) {
																			newUserModel.roleMap[companyId].push(data.fieldSSORoleId);																
																		} else {
																			newUserModel.roleMap[companyId].push(data.roleId);	
																		}
																		return newUserModel;
																	},
																	actualCall: function(data) {
																		return Service.getUserService().addNewUser(data);
																	},
																	success: function(data, responseData) {													
																		window.DL.MessageUtil.showToast('Success', 'Added new user', {									
																			theme: 'success',
																			position: 'top-stretch'
																		});
																		actionRefresh();
																		addWin.close();
																	}
																});
															}
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',												
													listeners: {
														click: function() {
															addWin.close();
														}
													}
												}
											]
										}
									]
								});

								addWin.addToContentElement(formPanel);
							}
						}
					});
					};

					var companyId = ElementUtil.query(toolbar, 'filtercompany').value;
					if (!companyId) {
						Service.getCompanyService().getCurrentCompany().then(function(fullCompany){
							companyId = fullCompany.company.companyId;
							showAddWin(companyId);
						});
					} else {
						showAddWin(companyId);
					}					

				});
				
			}
		};
		
		var actionResetPassword = function(record) {
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Reset Password',
				message: 'Are you sure you want to reset password for user <b>' + record.userId + '</b>?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Resetting password...');													
							
							Service.getUserService().resetPassword(record.userId).then(function(result){
								loadMask.remove();								
								window.DL.MessageUtil.showOkMessage(record.userId + ' password was reset to ' + result.data.resetpassword);																
							});
						}	
					},
					{
						text: 'No'
					}
				]
			});			
		};
		
		var actionActivateDisable = function(record) {
			
			if (record.activeStatus !== 'A') {
				var loadMask = grid.showLoading('Activate user...');
				Service.getUserService().activateUser(record.userId).then(function(){
					loadMask.remove();

					window.DL.MessageUtil.showToast('Success', 'Activated user: ' + record.userId, {									
						theme: 'success'
					});
					actionRefresh();
				});
			} else {
				var loadMask = grid.showLoading('Inactive user...');
				Service.getUserService().inactivateUser(record.userId).then(function(){
					loadMask.remove();

					window.DL.MessageUtil.showToast('Success', 'Inactivated user: ' + record.userId, {									
						theme: 'success'
					});
					actionRefresh();
				});				
			}
		};
		
		var actionLock = function(record) {
			
			if (record.accountStatus === 'A') {
				var loadMask = grid.showLoading('Lock user...');
				Service.getUserService().lockUser(record.userId).then(function(){
					loadMask.remove();

					window.DL.MessageUtil.showToast('Success', 'Locked user: ' + record.userId, {									
						theme: 'success'
					});
					actionRefresh();
				});				
			} else {
				var loadMask = grid.showLoading('Unlocking user...');
				Service.getUserService().unlockUser(record.userId).then(function(){
					loadMask.remove();

					window.DL.MessageUtil.showToast('Success', 'Unlocked user: ' + record.userId, {									
						theme: 'success'
					});
					actionRefresh();
				});
			}
			
		};
		
		var actionCompanies = function(record) {
			
			var companyWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Manage Companies',
				icon: 'vaadin:building',
				listeners: {
					ready: function() {						
						companyWin.show();
						
						var companyToolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'toolbar',
							theme: 'spacing',
							children: [								
								{
									tag: 'vaadin-button',
									'class': 'spacer-toolbar-item',
									theme: 'primary',
									children:[
										ElementUtil.makeIcon('vaadin:plus', ' Add')
									],
									listeners: {
										click: function() {
											actionAddCompany();
										}
									}
								},
								{
									tag: 'dl-action-button',
									theme: 'primary',
									itemid: 'edit',
									disabled: true,
									'class': 'spacer-toolbar-item',
									children:[
										ElementUtil.makeIcon('vaadin:edit', ' Edit')
									],
									listeners: {
										click: function() {
											actionEditCompany(companyGrid.selectedItems[0]);
										}
									}
								},
								{
									tag: 'dl-action-button',						
									theme: 'error primary',
									itemid: 'delete',
									disabled: true,
									'class': 'spacer-toolbar-item',
									style: 'float: right;',
									children:[
										ElementUtil.makeIcon('vaadin:trash', ' Delete')
									],
									listeners: {
										click: function() {
											actionRemoveCompany(companyGrid.selectedItems[0]);
										}
									}
									
								}
							]
						});

						var companyGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',
							slot: 'primary',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true
							},			
							children: [				
								{						
									path: 'companyName',
									header: 'Company Name',					
									'flex-grow': '1'
								},
								{						
									path: 'managedAccountTypeDescription',
									header: 'Account Type',
									width: '8em'
								},
								{						
									path: 'primaryCompany',
									header: 'Primary Company',						
									width: '7em',
									'text-align': 'center',
									renderer: function(root, column, rowData) {	
										if (rowData.item.primaryCompany) {
											root.innerHTML = '<vaadin-icon icon="vaadin:check"></vaadin-icon>';
										} else {
											root.innerHTML = "";
										}
									}						
								}
							],
							listeners: {
								'active-item-changed': function(event) {
									const item = event.detail.value;
									companyGrid.selectedItems = item ? [item] : [];									
									if (companyGrid.selectedItems.length > 0) {
										ElementUtil.query(companyToolbar, 'edit').disabled = false;
										if (!item.primaryCompany) {
											ElementUtil.query(companyToolbar, 'delete').disabled = false; 						
										} else {
											ElementUtil.query(companyToolbar, 'delete').disabled = true; 
										}
									} else {
										ElementUtil.query(companyToolbar, 'edit').disabled = true;
										ElementUtil.query(companyToolbar, 'delete').disabled = true;
									}	
									
								}
							}
						});

						var companyGridLayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								companyToolbar,
								companyGrid
							]
						});
						
						companyWin.addToContentElement(companyGridLayout);						
						
						var companiesLoaded = [];
						var actionRefreshCompanies = function() {
							
							var loadMask = companyGrid.showLoading();
					
							Service.getUserService().getUserCompanies(record.userId).then(function(companies){
								companyGrid.activeItem = null;
								companyGrid.items = companies;
								companiesLoaded = companies;
								loadMask.remove();
							});
							
						};
						actionRefreshCompanies();
						
						var actionAddCompany = function() {
						
							var addCompanyWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: 'Add Company',
								icon: 'vaadin:building',
								width: '400px',
								height: '320px',
								listeners: {
									ready: function() {						
										addCompanyWin.show();
										
										var addCompanyformPanel = ElementUtil.create({
											tag: 'dl-form-panel',								
											itemid: 'form',
											children: [
												{										
													tag: 'vaadin-form-layout',
													children: [	
														{
															tag: 'vaadin-combo-box',															
															label: 'Company',
															name: 'companyId',
															'item-value-path': 'code',
															'item-label-path': 'description',
															required: true,
															postinit: function(combo) {
																Service.getCompanyService().getCompaniesLookup().then(function(data){
																	
																	var companyMap = {};
																	companiesLoaded.forEach(function(inCompany){
																		companyMap[inCompany.companyId] = inCompany.companyName;
																	});
																	
																	//load companies minus the existing
																	var companiesToSelected = [];
																	data.forEach(function(item) {
																		if (!companyMap[item.code]) {
																			companiesToSelected.push(item);
																		}																																				
																	});
																	
																	combo.items = companiesToSelected;
																});
															},
															placeHolder: 'Select'
														},
														{
															tag: 'vaadin-combo-box',
															label: 'Account Type',
															name: 'managedAccountType',
															'item-value-path': 'code',
															'item-label-path': 'description',
															placeHolder: 'Select',
															'clear-button-visible': true,
															postinit: function(combo) {
																Service.getLookupService().getLookupValues('ManagedAccountType').then(function(data){
																	combo.items = data;
																});
															}
														},
														{
															tag: 'vaadin-checkbox',
															name: 'primary',
															label: 'Primary Company'
														}														
													]
												},
												{
													tag: 'hr',
													colspan: 2
												},
												{
													tag: 'div',
													style: 'text-align: center;',
													colspan: 2,
													defaults: {
														tag: 'vaadin-button'
													},
													children: [
														{
															theme: 'primary',
															children: [
																ElementUtil.makeIcon('vaadin:plus', ' Add')
															],
															listeners: {
																click: function() {		
																	
																	if (addCompanyformPanel.isValid()) {
																		
																		var formData = addCompanyformPanel.getData();
																		
																		var loadMask = companyWin.showLoading('Add company to user...');
																		Service.getUserService().addUserToCompanies(record.userId, formData.companyId, formData.primary, formData.managedAccountType).then(function() {

																			window.DL.MessageUtil.showToast('Success', 'Add company to user: ' + record.userId, {									
																				theme: 'success'
																			});								

																			actionRefreshCompanies();
																			loadMask.remove();
																			addCompanyWin.close();
																		});
																		
																	}																	
																}
															}
														},
														{
															theme: 'tertiary',
															innerHTML: 'Cancel',
															style: 'margin-left: 10px;',												
															listeners: {
																click: function() {
																	addCompanyWin.close();
																}
															}
														}
													]
												}
											]
										});										
										
										addCompanyWin.addToContentElement(addCompanyformPanel);
										
									}
								}
							});
														
						};

						var actionEditCompany = function(selectedCompany) {
							
							var editCompanyWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: 'Edit Company Assignment',
								icon: 'vaadin:edit',
								width: '400px',
								height: '320px',
								listeners: {
									ready: function() {
										editCompanyWin.show();
										
										var editCompanyformPanel = ElementUtil.create({
											tag: 'dl-form-panel',
											itemid: 'form',
											children: [
												{
													tag: 'vaadin-form-layout',
													children: [
														{
															tag: 'vaadin-text-field',
															label: 'Company',
															name: 'companyName',
															readonly: true,
															value: selectedCompany.companyName
														},
														{
															tag: 'vaadin-combo-box',
															label: 'Account Type',
															name: 'managedAccountType',
															'item-value-path': 'code',
															'item-label-path': 'description',
															placeHolder: 'Select',
															'clear-button-visible': true,
															value: selectedCompany.managedAccountType || '',
															postinit: function(combo) {
																Service.getLookupService().getLookupValues('ManagedAccountType').then(function(data){
																	combo.items = data;
																	if (selectedCompany.managedAccountType) {
																		combo.value = selectedCompany.managedAccountType;
																	}
																});
															}
														},
														{
															tag: 'vaadin-checkbox',
															name: 'primary',
															label: 'Primary Company',
															properties: {
																checked: !!selectedCompany.primaryCompany
															}
														}
													]
												},
												{
													tag: 'hr',
													colspan: 2
												},
												{
													tag: 'div',
													style: 'text-align: center;',
													colspan: 2,
													defaults: {
														tag: 'vaadin-button'
													},
													children: [
														{
															theme: 'primary',
															children: [
																ElementUtil.makeIcon('vaadin:check', ' Save')
															],
															listeners: {
																click: function() {
																	
																	if (editCompanyformPanel.isValid()) {
																		
																		var formData = editCompanyformPanel.getData();
																		
																		var loadMask = companyWin.showLoading('Update company assignment...');
																		Service.getUserService().updateUserCompany(
																			record.userId,
																			selectedCompany.companyId,
																			formData.primary,
																			formData.managedAccountType
																		).then(function() {

																			window.DL.MessageUtil.showToast('Success', 'Updated company assignment for: ' + record.userId, {
																				theme: 'success'
																			});

																			actionRefreshCompanies();
																			loadMask.remove();
																			editCompanyWin.close();
																		});
																		
																	}
																}
															}
														},
														{
															theme: 'tertiary',
															innerHTML: 'Cancel',
															style: 'margin-left: 10px;',
															listeners: {
																click: function() {
																	editCompanyWin.close();
																}
															}
														}
													]
												}
											]
										});
										
										editCompanyWin.addToContentElement(editCompanyformPanel);
									}
								}
							});
							
						};
						
						var actionRemoveCompany = function(selectedCompany) {
							
							var loadMask = companyWin.showLoading('Removing company from user...');
							Service.getUserService().deleteUserFromCompany(record.userId, selectedCompany).then(function() {
								
								window.DL.MessageUtil.showToast('Success', 'Removed company from user: ' + record.userId, {									
									theme: 'success'
								});								
								actionRefreshCompanies();
								loadMask.remove();
							});
							
						};
					}
				}
			});
			
		};
		
		var actionUserLookup = function() {
			
			var userWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'User Lookup',
				icon: 'vaadin:user',
				listeners: {
					ready: function() {						
						userWin.show();
						
						var hasPrimaryCompany = function(userView) {
							return !!(userView && userView.primaryCompany && userView.primaryCompany.companyId);
						};

						var updateLookupButtons = function() {
							var selectButton = ElementUtil.query(userGridLayout, 'selectbtn');
							var assignCompanyButton = ElementUtil.query(userGridLayout, 'assigncompanybtn');
							var selectedUser = userGrid.selectedItems.length > 0 ? userGrid.selectedItems[0] : null;
							if (selectButton) {
								selectButton.disabled = !(selectedUser && hasPrimaryCompany(selectedUser));
							}
							if (assignCompanyButton) {
								assignCompanyButton.disabled = !(selectedUser && !hasPrimaryCompany(selectedUser));
							}
						};
						
						var userToolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'toolbar',
							theme: 'spacing',
							children: [								
								{
									tag: 'vaadin-combo-box',
									label: 'Search Field',
									itemid: 'userFilterField',
									'item-value-path': 'code',
									'item-label-path': 'description',
									required: true,
									value: 'userId',
									postinit: function (combo) {
										combo.items = [
											{
												code: 'userId',
												description: 'User Id'
											},
											{
												code: 'firstname',
												description: 'First Name'
											},
											{
												code: 'lastname',
												description: 'Last Name'
											}
										];						
									}
								},				
								{
									tag: 'vaadin-text-field',
									itemid: 'userFilterValue',
									'class': 'spacer-toolbar-item',									
									label: 'Search By',
									listeners: {
										input: {
											fn: function() {
												actionFindUsers();
											},
											buffer: 2000
										}
									}
								},
								{
									tag: 'vaadin-button',
									'class': 'spacer-toolbar-item',
									children:[
										ElementUtil.makeIcon('vaadin:search', ' Search')
									],
									listeners: {
										click: function() {
											actionFindUsers();
										}
									}
								}
							]
						});

						var userGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',
							slot: 'primary',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true
							},			
							children: [				
								{						
									path: 'userId',
									header: 'Username',					
									width: '9em',
									renderer: function(root, column, rowData) {										
										root.innerHTML = rowData.item.userProfile.userId;
									}
								},
								{						
									path: 'firstname',
									header: 'First Name',						
									width: '5em',
									renderer: function(root, column, rowData) {															
										root.innerHTML = rowData.item.userProfile.firstname;
									}						
								},
								{						
									path: 'lastname',
									header: 'Last Name',						
									width: '5em',
									renderer: function(root, column, rowData) {										
										root.innerHTML = rowData.item.userProfile.lastname;
									}						
								},				
								{						
									path: 'company',
									header: 'Company Name',
									'flex-grow': '1',
									renderer: function(root, column, rowData) {
										if (hasPrimaryCompany(rowData.item)) {
											root.innerHTML = rowData.item.primaryCompany.companyName;
										} else {
											root.innerHTML = '<span style="color: var(--lumo-error-text-color); font-style: italic;">Missing company Assignment</span>';
										}
									}
								}
							],
							listeners: {
								'active-item-changed': function(event) {
									const item = event.detail.value;
									userGrid.selectedItems = item ? [item] : [];
									updateLookupButtons();
								}
							}
						});

						var userGridLayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								userToolbar,
								userGrid,
								{
									tag: 'div',
									style: 'text-align: center;',
									slot: 'footer',
									defaults: {
										tag: 'vaadin-button'
									},
									children: [
										{
											theme: 'primary',
											itemId: 'selectbtn',
											disabled: true,
											children: [
												ElementUtil.makeIcon('vaadin:database', ' Select')
											],
											listeners: {
												click: function() {		
													var selectUser = userGrid.selectedItems[0];
													if (!hasPrimaryCompany(selectUser)) {
														window.DL.MessageUtil.showOkMessage('Selected user is missing a company assignment. Use Assign Company first.');
														return;
													}
													ElementUtil.query(toolbar, 'filtercompany').value = selectUser.primaryCompany.companyId; 
													ElementUtil.query(toolbar, 'filterValue').value = selectUser.userProfile.userId;
													actionRefresh();
													userWin.close();
												}
											}
										},
										{
											theme: 'primary',
											itemId: 'assigncompanybtn',
											disabled: true,
											style: 'margin-left: 10px;',
											children: [
												ElementUtil.makeIcon('vaadin:building', ' Assign Company')
											],
											listeners: {
												click: function() {
													actionAssignCompany(userGrid.selectedItems[0]);
												}
											}
										},
										{
											theme: 'tertiary',
											innerHTML: 'Cancel',
											style: 'margin-left: 10px;',												
											listeners: {
												click: function() {
													userWin.close();
												}
											}
										}
									]										

								}
							]
						});
						
						userWin.addToContentElement(userGridLayout);
						
						var actionFindUsers = function(preferredUserId) {
								
							var currentFilter = {
								sortField: 'userId',
								filterField: ElementUtil.query(userToolbar, 'userFilterField').value,
								filterValue: ElementUtil.query(userToolbar, 'userFilterValue').value
							};
							
							var loadMask = userGrid.showLoading();					
							Service.getUserService().getUsers(currentFilter).then(function(users){
								userGrid.activeItem = null;
								userGrid.items = users.data;
								userGrid.selectedItems = [];
								if (preferredUserId && users.data) {
									var matchedUser = users.data.find(function(userView) {
										return userView.userProfile && userView.userProfile.userId === preferredUserId;
									});
									if (matchedUser) {
										userGrid.activeItem = matchedUser;
										userGrid.selectedItems = [matchedUser];
									}
								}
								updateLookupButtons();
								loadMask.remove();
							});
				
						};

						var actionAssignCompany = function(selectedUser) {
							if (!selectedUser || !selectedUser.userProfile) {
								return;
							}

							var assignCompanyWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: 'Assign Company',
								icon: 'vaadin:building',
								width: '400px',
								height: '280px',
								listeners: {
									ready: function() {
										assignCompanyWin.show();

										var assignCompanyFormPanel = ElementUtil.create({
											tag: 'dl-form-panel',
											itemid: 'form',
											children: [
												{
													tag: 'vaadin-form-layout',
													children: [
														{
															tag: 'vaadin-text-field',
															label: 'User',
															readonly: true,
															value: selectedUser.userProfile.userId
														},
														{
															tag: 'vaadin-combo-box',
															label: 'Company',
															name: 'companyId',
															'item-value-path': 'code',
															'item-label-path': 'description',
															required: true,
															postinit: function(combo) {
																Service.getCompanyService().getCompaniesLookup().then(function(data) {
																	combo.items = data;
																});
															},
															placeHolder: 'Select'
														}
													]
												},
												{
													tag: 'hr',
													colspan: 2
												},
												{
													tag: 'div',
													style: 'text-align: center;',
													colspan: 2,
													defaults: {
														tag: 'vaadin-button'
													},
													children: [
														{
															theme: 'primary',
															children: [
																ElementUtil.makeIcon('vaadin:check', ' Assign')
															],
															listeners: {
																click: function() {
																	if (assignCompanyFormPanel.isValid()) {
																		var formData = assignCompanyFormPanel.getData();
																		var loadMask = assignCompanyWin.showLoading('Assigning company...');
																		Service.getUserService().addUserToCompanies(
																			selectedUser.userProfile.userId,
																			formData.companyId,
																			true
																		).then(function() {
																			window.DL.MessageUtil.showToast('Success', 'Assigned company for: ' + selectedUser.userProfile.userId, {
																				theme: 'success'
																			});
																			loadMask.remove();
																			assignCompanyWin.close();
																			actionFindUsers(selectedUser.userProfile.userId);
																		}).catch(function() {
																			loadMask.remove();
																		});
																	}
																}
															}
														},
														{
															theme: 'tertiary',
															innerHTML: 'Cancel',
															style: 'margin-left: 10px;',
															listeners: {
																click: function() {
																	assignCompanyWin.close();
																}
															}
														}
													]
												}
											]
										});

										assignCompanyWin.addToContentElement(assignCompanyFormPanel);
									}
								}
							});
						};
						
					}
				}
			});			
						
		};
		
	}
	
};
customElements.define('dl-user-grid', UserGrid);
